// @flow
import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import ReactHTMLParser from 'react-html-parser';
import useOnScreen from '@latitude/core/hooks/useOnScreen';
import Typography from '@latitude/typography';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';

const parseContent = content => {
  if (React.isValidElement(content)) {
    return content;
  }
  if (typeof content === 'string') {
    return ReactHTMLParser(content);
  }
  return '';
};

const AccordionContent = props => {
  const {
    id,
    buttonId,
    isParent,
    isOpen,
    isChild,
    contentBgColor,
    content,
    activeIndex,
    nestedAccordion,
    style,
    hasSmoothScroll
  } = props;
  const allowSmoothScrolling =
    hasSmoothScroll !== undefined ? hasSmoothScroll : true;
  const [checkOnScreenStatus, updateCheckOnScreenStatus] = useState(false);
  const contentDiv = useRef();
  const contentRef = useRef();
  const contentOnScreen = useOnScreen(contentDiv);

  // calculates the position of the accordion according to the current scroll and scrolls to the opening item
  useEffect(() => {
    if (
      checkOnScreenStatus &&
      !contentOnScreen &&
      contentDiv &&
      contentDiv.current &&
      typeof window !== 'undefined'
    ) {
      let offsetHeight = 100;

      // need to offset the sticky header if it exists
      const headerElement =
        typeof document !== 'undefined' &&
        document.getElementsByTagName('header');
      if (headerElement && headerElement[0]) {
        offsetHeight += headerElement[0].offsetHeight;
      }

      // if within a nested accordion, need to also offset the parent button height
      if (isChild) {
        offsetHeight += 100;
      }

      const scrollYPosition =
        window.pageYOffset +
        contentDiv.current.getBoundingClientRect().top -
        offsetHeight;
      updateCheckOnScreenStatus(false);

      if (allowSmoothScrolling) {
        window.scrollTo({ left: 0, top: scrollYPosition, behavior: 'smooth' });
      }
    }
  }, [checkOnScreenStatus]);

  useEffect(() => {
    if (contentDiv && contentDiv.current && !contentOnScreen) {
      const timeout = setTimeout(() => {
        updateCheckOnScreenStatus(true);
      }, 100);
      return () => clearTimeout(timeout);
    }
    return undefined;
  }, [activeIndex]);

  return (
    <div
      id={id}
      role="tabpanel"
      style={style}
      aria-labelledby={buttonId}
      ref={contentRef}
      className={classnames(
        'accordion__item-body',
        'accordion-content',
        isOpen && 'open',
        !isParent && contentBgColor
      )}
      style={{
        '--accordion-content-height': `${contentRef.current?.scrollHeight}px`
      }}
    >
      {/* Empty div in order to tell when the top of the content is not on screen */}
      <div ref={contentDiv} />
      <Typography.Body color={REBRAND_COLOR.INDIGO}>
      {isParent ? nestedAccordion : parseContent(content)}
      </Typography.Body>
    </div>
  );
};

export default AccordionContent;